// Public UI adapted from Klargo-Reference/components/ds/tones.ts.
export const DS_TONES = {
    green: { bg: 'var(--ds-green-bg)', fg: 'var(--ds-green-deep)', dot: 'var(--ds-green)' },
    blue: { bg: 'var(--ds-buyer-bg)', fg: 'var(--ds-buyer-fg)', dot: 'var(--ds-buyer)' },
    wine: { bg: 'var(--ds-seller-bg)', fg: 'var(--ds-seller-fg)', dot: 'var(--ds-seller)' },
    amber: { bg: 'var(--ds-amber-bg)', fg: 'var(--ds-amber-fg)', dot: 'var(--ds-amber)' },
    red: { bg: 'var(--ds-red-bg)', fg: 'var(--ds-red-fg)', dot: 'var(--ds-red)' },
    slate: { bg: 'var(--ds-slate-bg)', fg: 'var(--ds-slate-fg)', dot: 'var(--ds-slate)' },
    neutral: { bg: 'var(--ds-neutral-bg)', fg: 'var(--ds-text)', dot: 'var(--ds-muted)' },
};
